import React from "react";

import { UserDropDownMenu } from "components/molecules";
import { useSelector } from "react-redux";
import DefaultImg from "assets/images/PNG/blank.png";
import { SmartImage } from "components/atoms";

function HeaderTopbarBase() {
  const { me } = useSelector((state) => state.me);
  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-3">
        <p className="font-medium text-mono text-[14px]">{me?.name}</p>
      </div>
      <UserDropDownMenu
        trigger={
          <div className="cursor-pointer size-9 rounded-full justify-center shrink-0 overflow-hidden">
            <SmartImage
              src={me?.profile_url ?? DefaultImg}
              alt="User"
              fallback={
                <div className="bg-[#d3e6ff] flex justify-center items-center">
                  <img
                    src={DefaultImg}
                    alt="flag"
                    className="w-full h-full object-cover"
                  />
                </div>
              }
            />
          </div>
        }
      />
    </div>
  );
}

export const HeaderTopbar = React.memo(HeaderTopbarBase);
